    import { Component, OnInit, Input, Output, EventEmitter,  ViewChild, ElementRef } from '@angular/core';
    import { FormBuilder, FormGroup, Validators } from '@angular/forms';
    import { AguasService } from '../../servicios/aguas.service';
    import { CatUsuariosService } from '../../servicios/cat-usuarios.service';
    import { CatEstatusService } from '../../servicios/cat-estatus.service';
    import { CatAguaZonasService } from '../../servicios/cat-agua-zonas.service';
    import { CatTipoServiciosService } from '../../servicios/cat-tipo-servicios.service';
    import { CatTipoTomas_Service } from '../../servicios/cat-tipo-tomas.service';
    import { CatTipoUsosService } from '../../servicios/cat-tipo-usos.service';
    import { CatTipoConsumosService } from '../../servicios/cat-tipo-consumos.service';
    import { CatTipoPeriodosService } from '../../servicios/cat-tipo-periodos.service';
    import { CatDiametroTomasService } from '../../servicios/cat-diametro-tomas.service';
    import { CatCallesService } from '../../servicios/cat-calles.service';
    import { CatMunicipiosService } from '../../servicios/cat-municipios.service';
    import { CatColoniasService } from '../../servicios/cat-colonias.service';
    import { CatTipoGirosService } from '../../servicios/cat-tipo-giros.service';
    import { CatRutasService } from '../../servicios/cat-rutas.service';
    import { CatTipoContratoPersonasService } from "../../servicios/cat-tipo-contrato-personas.service";
    import { ActivatedRoute } from '@angular/router';
    import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
    import { Aguas, CatDelegaciones, CatTipoContratoPersonas, DatosPadronInpunt, GetContratos } from '../../entidades/entidades';
    import { CatUsuarios } from '../../entidades/entidades';
    import { CatEstatus } from '../../entidades/entidades';
    import { CatAguaZonas } from '../../entidades/entidades';
    import { CatTipoServicios } from '../../entidades/entidades';
    import { CatTipoTomas_ } from '../../entidades/entidades';
    import { CatTipoUsos } from '../../entidades/entidades';
    import { CatTipoConsumos } from '../../entidades/entidades';
    import { CatTipoPeriodos } from '../../entidades/entidades';
    import { CatDiametroTomas } from '../../entidades/entidades';
    import { Solicitudes } from '../../entidades/entidades';
    import { CatCalles } from '../../entidades/entidades';
    import { CatMunicipios } from '../../entidades/entidades';
    import { CatColonias } from '../../entidades/entidades';
    import { CatTipoGiros } from '../../entidades/entidades';
    import { CatRutas,DatosDeCobro } from '../../entidades/entidades';
    import { MenuItem, SelectItem } from "primeng/api";
    import { CatDelegacionesService } from 'app/servicios/cat-delegaciones.service';
    import { DatosPadron } from '../../entidades/entidades';
    import { DatosPadronService} from 'app/servicios/datos-padron.service';
    
    @Component({
        selector: 'app-aguas',
        templateUrl: './aguas.component.html',
        styleUrls: ['./aguas.component.css']
    })
    export class AguasComponent implements OnInit {
        muestraMensaje = new MuestraMensaje();
        catUsuarios: CatUsuarios[] = [];
        catEstatus: CatEstatus[] = [];
        catAguaZonas: CatAguaZonas[] = [];
        catTipoServicios: CatTipoServicios[] = [];
        catTipoTomas: CatTipoTomas_[] = [];
        catTipoTomasClon: CatTipoTomas_[] = [];
        catTipoUsos: CatTipoUsos[] = [];
        catTipoConsumos: CatTipoConsumos[] = [];
        catTipoPeriodos: CatTipoPeriodos[] = [];
        catDiametroTomas: CatDiametroTomas[] = [];
        solicitudes: Solicitudes[] = [];
        catCalles: CatCalles[]=[];
        catMunicipios: CatMunicipios[] = [];
        catColonias: CatColonias[] = [];
        catTipoGiros: CatTipoGiros[] = [];
        catRutas: CatRutas[] = [];
        catTipoContratoPersonas: CatTipoContratoPersonas[] = [];
        aguasForm: FormGroup;
        anioGenerado: number = 0;
        catDelegaciones: CatDelegaciones[] = [];
        auxDelegacion: number;
        auxColonias: string;
        auxCalle: number;
        auxAZona: number;
        auxGiro: number;
        fechaInstalacionMedidor: Date;
        public datAgua: number;
        private previousAguaId: number;
    
    
        public tieneInfraestructura: boolean = true;
        public tieneAgua: boolean = true;
        public tieneDrenaje: boolean = true;
        public tieneSaneamiento: boolean = true;
        public esPredioSinToma: boolean = false;
        public mustraDiametroDrenaje: boolean = false;
        public aniosInfraestructura : SelectItem[];

        contratos: GetContratos[] = [];
        clonedContratos: { [s: string]: GetContratos } = {};
        columnasTabla: any[];
        itemsMenu: MenuItem[];
        catTipoContratos: SelectItem[];
    
        //VARIABLES ALTA PREDIO SIN TOMA O RECTIFICACION
        @Input('esRectificacion') esRectificacion: boolean = false;
        @Input('esAltaContrato') esAltaContrato: boolean = false;    
        @Input('readOnly') readOnly: boolean = false;    
        j: number;
        @Input('tipoUsoSolicitud') tipoUsoSolicitud: number;
        @Input('aguas') aguas: Aguas;
        @Output('aguasOutput') aguasOutput: EventEmitter<Aguas>;
        @Output('contratoType') contratoType: EventEmitter<number>;
        @Input('tipoContratoSelect') tipoContratoSelect: number;
        @Input("padron") padron: boolean = false;
        @Input() altaDerivada: boolean = false;
        display: boolean = false;
    
        @ViewChild('fechaInstalacion') fechaInstalacion: ElementRef;

        public progressBar: boolean = false;

     
    showDialog() {
        this.display = true;
    }


    constructor(
        private formBuilder: FormBuilder,
        private aguasService: AguasService,
        private catUsuariosService: CatUsuariosService,
        private catEstatusService: CatEstatusService,
        private catAguaZonasService: CatAguaZonasService,
        private catTipoServiciosService: CatTipoServiciosService,
        private catTipoTomasService: CatTipoTomas_Service,
        private catTipoUsosService: CatTipoUsosService,
        private catTipoConsumosService: CatTipoConsumosService,
        private catTipoPeriodosService: CatTipoPeriodosService,
        private catDiametroTomasService: CatDiametroTomasService,
        private catCallesService: CatCallesService,
        private catMunicipiosService: CatMunicipiosService,
        private catColoniasService: CatColoniasService,
        private catTipoGirosService: CatTipoGirosService,
        private catRutasService: CatRutasService,
        private catDelegacionesService: CatDelegacionesService,
        private catTipoContratoPersonasService: CatTipoContratoPersonasService,
        private datosPadronService: DatosPadronService,
    ) {
        this.aguasOutput = new EventEmitter();
        this.contratoType = new EventEmitter();
    }

    async ngOnInit() {
        try {
            this.progressBar = true;
            this.columnasTabla = [
                { field: "operacion", header: "Editar", ordenar: false, styleHeader: "width: 5%; min-width: 50px;" },
                { field: 'idTipoContrato', header: 'Tipo de Contrato', ordenar: true, styleHeader: 'width: 10%' },
                { field: 'numContrato', header: 'Número de Contrato', ordenar: true, styleHeader: 'width: 15%' },
                { field: 'fecha', header: 'Fecha Contrato', ordenar: true, styleHeader: 'width: 15%' },
            ];
            this.itemsMenu = [
                { label: "Agregar", icon: "pi pi-file-o", command: () => this.add(), },
            ];         
        
            this.aguasForm = this.formBuilder.group({
                id: [undefined],
                cp: [undefined, [Validators.maxLength(5)]],
                cuentaAguaAnterior: [undefined],
                cuentaAgua: [undefined],
                idUsuarioGuardo: [undefined],
                fechaAlta: [Date],
                fechaBaja: [undefined],
                idEstatus: [undefined],
                idAguaZona: [undefined],
                idTipoServicio: [3],
                idTipoToma: [undefined],
                idTipoUso: [undefined],
                idTipoConsumo: [undefined],
                fechaUltimoPago: [undefined],
                idTipoPeriodoUp: [undefined],
                periodoAnioUp: [undefined],
                periodoParcialidadUp: [undefined],
                porcentajeConstruccion: [undefined],
                observaciones: [undefined, [Validators.maxLength(250)]],
                idDiametroToma: [undefined],
                idDiametroDrenaje: [undefined],
                fechaCorte: [undefined],
                idSolicitud: [undefined],
                derivada: [undefined],
                cveMun: [undefined, [Validators.maxLength(10), /* Validators.pattern(/^[0-9]+\.?[0-9]*$/) */]],
                cveZona: [undefined, [Validators.maxLength(10),/*  Validators.pattern(/^[0-9]+\.?[0-9]*$/) */]],
                cveLoc: [undefined, [Validators.maxLength(10), /* Validators.pattern((/^[0-9]+\.?[0-9]*$/)) */]],
                cveManz: [undefined, [Validators.maxLength(10),/*  Validators.pattern((/^[0-9]+\.?[0-9]*$/)) */]],
                cveLote: [undefined, [Validators.maxLength(10), /* Validators.pattern((/^[0-9]+\.?[0-9]*$/)) */]],
                cveEdif: [undefined,],
                cveDepto: [undefined,],
                cuentaPredial: [Number, [Validators.maxLength(10),]],
                tpPredial: [undefined, [Validators.maxLength(2)]],
                domicilio: [undefined, [Validators.maxLength(250)]],
                numeroLocal: [undefined, [Validators.maxLength(20)]],
                nombreLocal: [undefined, [Validators.maxLength(250)]],
                idCalle: [undefined],
                idCalleColinda1: [undefined],
                idCalleColinda2: [undefined],
                idMunicipio: [undefined],
                idColonia: [undefined],
                numExteror: [undefined, [Validators.maxLength(50)]],
                numInterior: [undefined, [Validators.maxLength(20)]],
                superficieConstruccion: [undefined],
                idTipoGiro: [undefined],
                idRuta: [undefined],
                idTipoContrato: [undefined],
                dato:[undefined], 
                idDelegacion:[undefined],
                cveCatastral: [undefined, [Validators.maxLength(30), /* Validators.pattern(/^[0-9]+\.?[0-9]*$/) */]],
                consecutivo: [undefined],
                selectedDelegacion: [null],
                selectedColonia: [null],
                selectedCalle: [null],
                selectedCalle1: [null],
                selectedCalle2: [null],
                selectedAguaZona: [null],
                selectedGiro: [null],
                letra: [undefined],
            });

            this.catDelegaciones = null;
            this.catColonias = null;
            this.catCalles = null;
            this.catAguaZonas = null;
            this.catTipoGiros = null;

            this.getAllCatUsuarios();
            this.getAllCatEstatus();
            this.getAllCatAguaZonas();
            this.getAllCatTipoServicios();
            this.getAllCatTipoTomas();
            this.getAllCatTipoUsos();
            this.getAllCatTipoConsumos();
            this.getAllCatTipoPeriodos();
            this.getAllCatDiametroTomas();
            this.getAllCatMunicipios();
            this.getAllCatTipoGiros();
            await this.getAllCatTipoContratoPersonas();
            await this.getAllCatDelegaciones();

            await this.buscaaguas();
            if (this.readOnly) {
                this.aguasForm.disable();
            } else {
                //this.aguasForm.enable();
            }
        } catch (e) {
            this.muestraMensaje.error(e , "top", "center");
            this.progressBar = false;
        }finally{
            this.progressBar = false;
           console.log("Paso por imprimir Recepción")
        };
    }
    async ngOnChanges() 
    {
        await this.buscaaguas()  
    }
    async buscaaguas(){
        if (this.aguas) {

            // Verificar si es la primera vez que se consulta la información, sino
            // mantiene el formulario con los datos que se cargaron previamente hasta que 
            // se consulte otra cuenta o se guarden los datos
            if (this.previousAguaId === null || this.aguas.id !== this.previousAguaId){

                this.borraDatos();

                this.datAgua = this.aguas.id;

                //this.catTipoContratoPersonas = this.catTipoContratoPersonas.filter((x) => x.id === this.aguas.idTipoContrato);
                
                if ([1, 3].includes(this.aguas.idTipoContrato)) {
                    this.mustraDiametroDrenaje = true;
                }else{
                    this.mustraDiametroDrenaje = false;
                }
                this.aguas.IdDiametroDrenaje;

                

                const opcionInicial = this.catDelegaciones.find(delegacion => delegacion.id === this.aguas.idDelegacion);
                if(opcionInicial) { await this.selectCatDelegacionesInicio(opcionInicial);}
                const colonia = this.catColonias.find(col => col.id === this.aguas.idColonia);
                if(colonia) {await this.selectOPtionAInicio(colonia);}
                const calle = this.catCalles.find(col => col.id === this.aguas.idCalle);
                const calle1 = this.catCalles.find(col => col.id === this.aguas.idCalleColinda1);
                const calle2 = this.catCalles.find(col => col.id === this.aguas.idCalleColinda2);
                const zonAgua = this.catAguaZonas.find(zAgua => zAgua.id === this.aguas.idAguaZona);
                if(zonAgua) { await this.selectCatZona(zonAgua);}
                const giro = this.catTipoGiros.find(giro => giro.id === this.aguas.idTipoGiro);
                if(giro) { await this.selectCatGiro(giro);}
            
                if (opcionInicial) {this.aguasForm.get('selectedDelegacion')?.setValue(opcionInicial);}
                if (colonia) {this.aguasForm.get('selectedColonia')?.setValue(colonia);}
                if (calle) {this.aguasForm.get('selectedCalle')?.setValue(calle);}
                if (calle1) {this.aguasForm.get('selectedCalle1')?.setValue(calle1);}
                if (calle2) {this.aguasForm.get('selectedCalle2')?.setValue(calle2);}
                if (zonAgua) { this.aguasForm.get('selectedAguaZona')?.setValue(zonAgua);}
                if (giro) { this.aguasForm.get('selectedGiro')?.setValue(giro);}
            
                const datoObjeto = JSON.parse(this.aguas.dato);

                this.tieneAgua = datoObjeto.agua ?? true;
                this.tieneDrenaje = (datoObjeto.dre ?? datoObjeto.drenaje) ?? true;
                this.tieneSaneamiento = (datoObjeto.sane ?? datoObjeto.saneamiento) ?? true;
                this.tieneInfraestructura = (datoObjeto.infra ?? datoObjeto.infraestructura) ?? true;         
              
                this.aguasForm.patchValue(this.aguas);
                const isoDate = (this.aguas?.fechaAlta ?? "").toString();
                const formattedDate = isoDate.split('T')[0];
                this.aguasForm.get('fechaAlta')?.setValue(formattedDate);

                this.formatoClaves(this.aguas);

                // Actualizar el valor de previousAguaId
                this.previousAguaId = this.aguas.id;
                
                await this.getAllDatosContrato();
                await this.getContratos();
            
                console.log('Entra a Aguas.componente: ', this.aguas);
            }
        }
    }


    async guardarAguas() {
        try {
            if (this.aguasForm.invalid) {throw new Error('No paso las validaciones.');}
            this.aguas = this.aguasForm.value;

            if(this.altaDerivada === true){
                this.aguas.cuentaAguaAnterior = null;
            }
            
            //SE PASAN ESTOS VALORES A ENTERO YA QUE EN EL FRONT SON DE TIPO TEXT PARA LIMITAR LA CANTIDAD DE CARACTERES
            this.aguas.cveMun  = parseInt(this.aguasForm.value.cveMun);
            this.aguas.cveZona = parseInt(this.aguasForm.value.cveZona);
            this.aguas.cveManz = parseInt(this.aguasForm.value.cveManz);
            this.aguas.cveLote = parseInt(this.aguasForm.value.cveLote);

            if(this.aguas.idAguaZona == null || this.aguas.idColonia == null)
            {    
                this.muestraMensaje.error('Los campos de colonia y zona no pueden ir vacíos.', 'top', 'center');
                return;   
            }
            this.aguas.dato = JSON.stringify({
                agua: this.tieneAgua,
                dre: this.tieneDrenaje,
                sane: this.tieneSaneamiento,
                infra: this.tieneInfraestructura
              });
            
            console.log("this.aguas: ", this.aguas);
            if (this.aguas.id) {
                await this.updateAguas(this.aguas);
            } else {
                this.aguas.id = 0;
                await this.addAguas(this.aguas);
            }
            this.aguasOutput.emit(this.aguas);
            this.muestraMensaje.notification('Proceso Concluido.', 'top', 'center');
        } catch (e) {
            this.muestraMensaje.error(e.message, 'top', 'center');
        } finally {
            console.log('Paso por guardarAguas');
        }
    }


    //====================================================
    //Metodos para obtener datos del servicio
    //====================================================
    async addAguas(aguas) {
        try {
            aguas.cveMun = parseInt(aguas.cveMun);
            aguas.cveZona = parseInt(aguas.cveZona);
            aguas.cveManz = parseInt(aguas.cveManz);
            aguas.cveLote = parseInt(aguas.cveLote);
            aguas.cveLoc = 1;
            aguas.cveSec = 1;
            

            console.log('Registro: ', aguas);
            const datoretorno = await this.aguasService.add(aguas).toPromise();

            this.aguas = datoretorno;
            //this.aguas.cveMun = this.aguas.cveMun.padStart(3,'0'); 
            this.aguasForm.patchValue(this.aguas);

            let auxFecha = this.aguas.fechaAlta.toString();
            let aux = auxFecha.split("T");
            console.log(aux);
            let dias = aux[0].split("-");
            console.log(dias);
            aux[0] = dias[2] + "/" + dias[1] + "/" + dias[0];
            let hora = aux[1].split(".");
            console.log(hora);
            let fechaFinal = aux[0] + " " + hora[0];
            console.log(fechaFinal);
            this.aguasForm.patchValue({
                fechaAlta: fechaFinal
            });

            if (this.aguas.fechaBaja != null) {
                auxFecha = this.aguas.fechaBaja.toString();
                aux = auxFecha.split("T");
                console.log(aux);
                dias = aux[0].split("-");
                console.log(dias);
                aux[0] = dias[2] + "/" + dias[1] + "/" + dias[0];
                hora = aux[1].split(".");
                console.log(hora);
                fechaFinal = aux[0] + " " + hora[0];
                console.log(fechaFinal);
                this.aguasForm.patchValue({
                    fechaBaja: fechaFinal
                });
            }


            this.formatoClaves(this.aguas);
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por addAguas');
        }
    }
   
    async cambiaAgua(evento)
    {
        this.tieneAgua = evento.checked;
    }
    async cambiaDrenaje(evento)
    {
        this.tieneDrenaje = evento.checked;
    }
    async cambiaSaneamiento(evento)
    {
        this.tieneSaneamiento = evento.checked;
    }
    async cambiaInfraestructura(evento)
    {
        this.tieneInfraestructura = evento.checked;
    }

  
    // async updateInfraestructuraDato(evento)
    // {
    //     if(evento.checked == true)
    //     {
    //         this.tieneInfraestructura = true;
    //     }else{
    //         this.tieneInfraestructura = false;
    //     }
    // }

    async validaNumericos(event) {
        if(event.charCode >= 48 && event.charCode <= 57){
          return true;
         }
         return false;        
    }
    async cambiaTipoServicios(tipoS)
    {
        
        let tipoServicio = this.aguasForm.value.idTipoServicio;
        console.log('TipoServicio: ',tipoServicio);
        if(!this.altaDerivada)
        {
            if(tipoServicio == 2)
            {
                this.esPredioSinToma = true;
            }else{
                this.esPredioSinToma = false;
                this.tieneInfraestructura = false
                this.anioGenerado = 0;
            }
        }
        
    }
    async validaEntrada(entrada)
    {
        console.log('validaEntrada: ', entrada)
    }
    async updateAguas(aguas) {
        try {
            aguas.cveMun = parseInt(aguas.cveMun);
            aguas.cveZona = parseInt(aguas.cveZona);
            aguas.cveManz = parseInt(aguas.cveManz);
            aguas.cveLote = parseInt(aguas.cveLote);

            console.log('Registro Update: ', aguas);
            const datoRetorno = await this.aguasService.update(aguas).toPromise();
            this.formatoClaves(this.aguas);
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por updateAguas');
        }
    }
    async deleteAguas(aguas: Aguas) {
        try {
            const datoRetorno = await this.aguasService.delete(aguas.id).toPromise();

            this.getAllAguas();
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por deleteAguas');
        }
    }
    async getAguas(id: number) {
        try {
            const datoRetorno = await this.aguasService.getSingle(id).toPromise();

            this.aguasForm.patchValue(datoRetorno);
            console.log('Agua 123: ', datoRetorno);
            this.formatoClaves(datoRetorno);

        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getAguas');
        }
    }
    async getAllAguas() {
        try {
            const datoRetorno = await this.aguasService.getAll().toPromise();
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getAllAguas');
        }
    }
    async getAllCatUsuarios() {
        try {
            const datoRetorno = await this.catUsuariosService.getAll().toPromise();
            this.catUsuarios = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatUsuarios');
        }
    }
    async getAllCatEstatus() {
        try {
            const datoRetorno = await this.catEstatusService.getEstatusPadron().toPromise();
            this.catEstatus = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatEstatus');
        }
    }
    async getAllCatAguaZonas() {
        try {
            const datoRetorno = await this.catAguaZonasService.getAll().toPromise();

            this.catAguaZonas = datoRetorno;

            console.log('Tipo:Zonas: ',this.catAguaZonas);
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatAguaZonas');
        }
    }
    async getAllCatTipoServicios() {
        try {
            const datoRetorno = await this.catTipoServiciosService
                .getAll()
                .toPromise();
            this.catTipoServicios = datoRetorno.filter(servicio => servicio.id === 3);    
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatTipoServicios');
        }
    }
    async getAllCatTipoTomas() {
        try {
            const datoRetorno = await this.catTipoTomasService.getAll().toPromise();
            console.log("RETORNA: ", datoRetorno);
            this.catTipoTomas = datoRetorno;
            /*this.catTipoTomasClon = datoRetorno;
            const numero = Object.keys(this.catTipoTomasClon);
            console.log('ESTO RETORNA', this.catTipoTomasClon);
            this.j = numero.length;
            console.log('J', this.j);
            
            console.log('this.altaDerivada 2: ',this.altaDerivada);
            if (this.altaDerivada === true) {
                this.catTipoTomas[0] = this.catTipoTomasClon[0];
                console.log('ES DERIVADA');
            }
            else if (this.altaDerivada === false) {
                this.catTipoTomas[0] = this.catTipoTomasClon[1];
                this.catTipoTomas[1] = this.catTipoTomasClon[2];
                console.log('ES APERTURA NORMAL');
            }

            console.log('ESTO se asigna', this.catTipoTomas);*/

        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatTipoTomas');
        }
    }
    async getAllCatTipoUsos() {
        try {
            const datoRetorno = await this.catTipoUsosService.getAll().toPromise();
            
                this.catTipoUsos = datoRetorno
            
            console.log('Tipo:Usos: ',this.catTipoUsos);

            
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatTipoUsos');
        }
    }
    async getAllCatTipoContratoPersonas(){
        try {
            const datoRetorno = await this.catTipoContratoPersonasService.getAll().toPromise();
            console.log("TIPO CONTRATO: ",datoRetorno);
            this.catTipoContratoPersonas = datoRetorno;

            this.catTipoContratos = datoRetorno
            .filter((datos) => datos.id === 2 || datos.id === 3) // Filtra solo los id 1 y 2
            .map((datos) => {
                return { label: datos.descripcion, value: datos.id };
            });
        
        this.catTipoContratos.unshift({ label: 'SELECCIONA...', value: null });
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getAllCatTipoContratoPersonas");
        }
    }
    onTipoContratoChange(event: any, rowcontratos: any) {
        console.log("Nuevo tipo de contrato seleccionado:", event.value);
        rowcontratos.idTipoContrato = event.value;
    }
    async getAllCatTipoConsumos() {
        try {
            const datoRetorno = await this.catTipoConsumosService
                .getAll()
                .toPromise();
            this.catTipoConsumos = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatTipoConsumos');
        }
    }
    async getAllCatTipoPeriodos() {
        try {
            const datoRetorno = await this.catTipoPeriodosService
                .getAll()
                .toPromise();
            this.catTipoPeriodos = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatTipoPeriodos');
        }
    }
    async getAllCatDiametroTomas() {
        try {
            const datoRetorno = await this.catDiametroTomasService
                .getAll()
                .toPromise();
            this.catDiametroTomas = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatDiametroTomas');
        }
    }
    async getAllCatDelegaciones() {
        try {
          const datoRetorno = await this.catDelegacionesService.getAll().toPromise();
          this.catDelegaciones = datoRetorno;
          if(!datoRetorno) return;
    
          this.catDelegaciones.unshift({
            baja: null,
            cambio: null,
            id: 0,
            descripcion: 'SELECCIONA...',
            idMunicipio: null,
            numRow: null, });
        } catch (e) {
          if (e.response) throw { message: e.response.data };
          else throw e;
        } finally {
          console.log('Paso por getAllCatDelegaciones');
        }
    }
    async getAllCatColonias() {
        try {
          const datoRetorno = await this.catColoniasService.getAll().toPromise();
          this.catColonias = datoRetorno;
          if(!datoRetorno) return;
    
          this.catColonias.unshift({
            baja: null,
            cambio: null,
            id: 0,
            descripcion: 'SELECCIONA...',
            idZona: null,
            idDelagacion: null,
            numRow: null, });
        } catch (e) {
          if (e.response) throw { message: e.response.data };
          else throw e;
        } finally {
          console.log('Paso por getCatColonias');
        }
      }
    async getAllCatMunicipios() {
        try {
            const datoRetorno = await this.catMunicipiosService.getAll().toPromise();
            this.catMunicipios = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatMunicipios');
        }
    }
 
    async getAllCatTipoGiros() {
        try {
            const datoRetorno = await this.catTipoGirosService.getAll().toPromise();
            this.catTipoGiros = datoRetorno;
            this.padron = true;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatTipoGiros');
        }
    }
    async getAllCatRutas() {
        try {
            const datoRetorno = await this.catRutasService.getAll().toPromise();
            this.catRutas = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatRutas');
        }
    }
  //Se realiza la consulta de los datos para el contrato de drenaje y las fechas
    //correspondientes
    async getContratos(){
        try
        {
            if(this.datAgua == null){
                return
            }
            let datosD = new DatosPadronInpunt
            datosD.idAgua = this.datAgua
            const valueRetorno = await this.datosPadronService.getContratos(datosD).toPromise();
            this.contratos = [];

            valueRetorno.forEach(element => {
                const contrato = new GetContratos();
                contrato.id = element.id;
                contrato.numContrato = element.numContrato;
                contrato.fecha = element.fecha;
                contrato.idTipoContrato = element.idTipoContrato;
                this.contratos.push(contrato);
            });
            for (var i = 0, len = this.contratos.length; i < len; i++) {
                this.contratos[i].numRow = i;
                this.clonedContratos[this.contratos[i].numRow] = { ...this.contratos[i], };
              }            
        }catch (e){
            if (e.response) throw { message: e.response.data };
            else throw e;
        }finally{
            console.log("Paso por getContratos")
        }

    }

    //Se realiza la consulta de los datos para el contrato de drenaje y las fechas
    //correspondientes
    async getAllDatosContrato(){
        try
        {
            if(this.datAgua == null){
                return
            }
            let datosD = new DatosPadronInpunt
            datosD.idAgua = this.datAgua
            const valueRetorno = await this.datosPadronService.postDatos(datosD).toPromise();
            if(Array.isArray(valueRetorno) && valueRetorno.length > 0){
                this.fechaInstalacionMedidor = valueRetorno[0].fechaInstalacionMedidor;
                this.pasaDatos();
            }else{
                return;
            }
        }catch (e){
            if (e.response) throw { message: e.response.data };
            else throw e;
        }finally{
            console.log("Paso por getDatosContrato")
        }

    }

    //Se asignan los datos a los campos correspondientes y se borra la informacion
    //después de un tiempo determinado
    pasaDatos(){   
        if(this.fechaInstalacion)
            this.fechaInstalacion.nativeElement.value = this.fechaInstalacionMedidor;
    }
    async borraDatos() {
        if(this.fechaInstalacion)
            this.fechaInstalacion.nativeElement.value = '';
    }



    // se agrega filtro de colonia segun la delegacion seleccionada
    async selectCatDelegaciones(delegacion) {
        if(!delegacion.value) return;
        this.auxDelegacion = delegacion.value.descripcion;
        const datoRetorno = await this.catColoniasService.getSingleDelegacion(delegacion.value.id).toPromise();
        this.catColonias = datoRetorno;
        this.aguasForm.patchValue({idDelegacion : delegacion.value.id}); 
    }

    async selectCatDelegacionesInicio(delegacion) {
        if(!delegacion.id) return;
        this.auxDelegacion = delegacion.descripcion;
        const datoRetorno = await this.catColoniasService.getSingleDelegacion(delegacion.id).toPromise();
        this.catColonias = datoRetorno;
        this.aguasForm.patchValue({idDelegacion : delegacion.id}); 
    }
    // se agrega filtro de calles segun la colonia seleccionada
    async selectOPtionA(colonias) {   
        if(!colonias.value) return;     
        this.auxColonias = colonias.value.descripcion;
        const datoRetorno = await this.catCallesService.getSingleColonias(colonias.value.id).toPromise();
        this.catCalles = datoRetorno;
        this.aguasForm.patchValue({idColonia : colonias.value.id}); 
    }
    async selectOPtionAInicio(colonias) {   
        if(!colonias.id) return;     
        this.auxColonias = colonias.descripcion;
        const datoRetorno = await this.catCallesService.getSingleColonias(colonias.id).toPromise();
        this.catCalles = datoRetorno;
        this.aguasForm.patchValue({idColonia : colonias.id}); 
    }
    // se agrega regreso del drop para agarrar la descripcion de la calle
    async selectCatCalles(calle: any, identifi: number) {    
        if(!calle.value) return;       
        this.auxCalle = calle.value.id;  
        switch (identifi) {
            case 0:
                this.aguasForm.patchValue({idCalle : this.auxCalle,}); 
                break;
            case 1:
                this.aguasForm.patchValue({idCalleColinda1 : this.auxCalle,}); 
                break;
            case 2:
                this.aguasForm.patchValue({idCalleColinda2 : this.auxCalle,}); 
                break;
          }
    }
    setTipoContrato(){
        const tipoContrato: number = this.aguasForm.get('idTipoContrato').value;
        if ([1, 3].includes(tipoContrato)) {
            this.mustraDiametroDrenaje = true;
        }else{
            this.mustraDiametroDrenaje = false;
        }
        this.contratoType.emit(tipoContrato);
    }
    async padStartMunicipio() {
        var muni = this.aguasForm.value.cveMun;
        let diferencia = 0;
        let i = 1;
        var municipio = '';
        let longitud = this.aguasForm.value.cveMun.toString().length;

        if (longitud > 0 && longitud < 3) {
            diferencia = 3 - longitud;
            municipio = '0';
            for (i; i < diferencia; i++) {
                municipio = municipio + '0';
            }
            municipio = municipio + muni;

            this.aguasForm.patchValue({
                cveMun: municipio,
            });
            console.log('municipio: ', municipio);
        }
    }
    async padStartZona() {
        var muni = this.aguasForm.value.cveZona;
        let diferencia = 0;
        let i = 1;
        var zona = '';
        let longitud = this.aguasForm.value.cveZona.toString().length;

        if (longitud > 0 && longitud < 2) {
            diferencia = 2 - longitud;
            zona = '0';
            for (i; i < diferencia; i++) {
                zona = zona + '0';
            }
            zona = zona + muni;
            this.aguasForm.patchValue({
                cveZona: zona,
            });
            console.log('zona: ', zona);
        }
   
    }
    async padStartManzana() {
        var muni = this.aguasForm.value.cveManz;
        let diferencia = 0;
        let i = 1;
        var manzana = '';
        let longitud = this.aguasForm.value.cveManz.toString().length;

        if (longitud > 0 && longitud < 3) {
            diferencia = 3 - longitud;
            manzana = '0';
            for (i; i < diferencia; i++) {
                manzana = manzana + '0';
            }
            manzana = manzana + muni;
            this.aguasForm.patchValue({
                cveManz: manzana,
            });
            console.log('manzana: ', manzana);
        }
    }
    async padStartLote() {
         var muni = this.aguasForm.value.cveLote;
         let diferencia = 0;
         let i = 1;
         var lote = '';
         let longitud = this.aguasForm.value.cveLote.toString().length;

         if (longitud > 0 && longitud < 2) {
            diferencia = 2 - longitud;
             lote = '0';
             for (i; i < diferencia; i++) {
                 lote = lote + '0';
             }
             lote = lote + muni;
             this.aguasForm.patchValue({
                 cveLote: null,
             });
           this.aguasForm.patchValue({
                 cveLote: lote,
             });
             console.log('Lote: ', lote);
        }
    }


    async padStartEdificio() {
        var muni = this.aguasForm.value.cveEdif;
        let diferencia = 0;
        let i = 1;
        var edificio = '';
        let longitud = this.aguasForm.value.cveEdif.toString().length;

        if (longitud > 0 && longitud < 2) {
            diferencia = 2 - longitud;
            edificio = '0';
            for (i; i < diferencia; i++) {
                edificio = edificio + '0';
            }
            edificio = edificio + muni;
            this.aguasForm.patchValue({
                cveEdif: edificio,
            });
            console.log('edificio: ', edificio);
        }
    }
    async padStartDepartamento() {
        var muni = this.aguasForm.value.cveDepto;
        let diferencia = 0;
        let i = 1;
        var departamento = '';
        let longitud = this.aguasForm.value.cveDepto.toString().length;

        if (longitud > 0 && longitud < 4) {
            diferencia = 4 - longitud;
            departamento = '0';
            for (i; i < diferencia; i++) {
                departamento = departamento + '0';
            }
            departamento = departamento + muni;
            this.aguasForm.patchValue({
                cveDepto: departamento,
            });
            console.log('departamento: ', departamento);
        }
    }
    async formatoClaves(aguas: Aguas) {

        if (aguas.id != 0) {
            //================ FORMATEO MUNICIPIO
            var muni = aguas.cveMun;
            let diferencia = 0;
            let i = 1;
            var municipio = '';
            if (aguas.cveMun) {
                let longitud = aguas.cveMun.toString().length;
                console.log('Municipio Entra: ', muni);

                if (longitud > 0 && longitud < 3) {
                    diferencia = 3 - longitud;
                    municipio = '0';
                    for (i; i < diferencia; i++) {
                        municipio = municipio + '0';
                    }
                    municipio = municipio + muni;

                    this.aguasForm.patchValue({
                        cveMun: municipio,
                    });
                    console.log('municipio: ', municipio);
                }
            } else {

            }

            //================ FORMATEO ZONA
            var zonaAct = aguas.cveZona;
            let diferenciaZona = 0;
            let z = 1;
            var zona = '';
            if (aguas.cveZona) {
                let longitudZona = aguas.cveZona.toString().length;

                if (longitudZona > 0 && longitudZona < 5) {
                    diferenciaZona = 5 - longitudZona;
                    zona = '0';
                    for (z; z < diferenciaZona; z++) {
                        zona = zona + '0';
                    }
                    zona = zona + zonaAct;
                    console.log('zona: ', zona);
                    this.aguasForm.patchValue({
                        cveZona: zona,
                    });
                    await this.concatenaClave();

                }
            } else {

            }

            //================ FORMATEO MANZANA
            var manzana = aguas.cveManz;
            let diferenciaManz = 0;
            let mz = 1;
            var manzF = '0';
            if (aguas.cveManz) {
                let longitudManz = aguas.cveManz.toString().length;
                if (longitudManz > 0 && longitudManz < 5) {
                    diferenciaManz = 5 - longitudManz;
                    for (mz; mz < diferenciaManz; mz++) {
                        manzF = manzF + '0';
                    }
                    manzF = manzF + manzana;
                    this.aguasForm.patchValue({
                        cveManz: manzF,
                    });
                    console.log('manzana: ', manzF);
                    await this.concatenaClave();
                }
            } else {

            }

            //================ FORMATEO LOTE
            var lote = aguas.cveLote;
            let diferenciaLote = 0;
            let l = 1;
            var lot = '';
            if (aguas.cveLote) {
                let longitudLote = aguas.cveLote.toString().length;

                if (longitudLote > 0 && longitudLote < 2) {
                    diferenciaLote = 5 - longitudLote;
                    lot = '0';
                    for (l; l < diferenciaLote; l++) {
                        lot = lot + '0';
                    }
                    lot = lot + lote;
                    this.aguasForm.patchValue({
                        cveLote: lot,
                    });
                    console.log('lote: ', lot);
                    await this.concatenaClave();
                }
            } else {

            }

            //================ FORMATEO EDIFICIO
            var edificioAct = aguas.cveEdif;
            let diferenciaEdif = 0;
            let e = 1;
            var edificio = '';
            if (aguas.cveEdif) {
                let longitudEdif = aguas.cveEdif.toString().length;

                if (longitudEdif > 0 && longitudEdif < 2) {
                    diferenciaEdif = 2 - longitudEdif;
                    edificio = '0';
                    for (e; e < diferenciaEdif; e++) {
                        edificio = edificio + '0';
                    }
                    edificio = edificio + edificioAct;
                    this.aguasForm.patchValue({
                        cveEdif: edificio,
                    });
                    console.log('edificio: ', edificio);
                }
            } else {

            }

            //================ FORMATEO DEPARTAMENTO
            var departamentoAct = aguas.cveDepto;
            let diferenciaDep = 0;
            let d = 1;
            var departamento = '';

            if (aguas.cveDepto) {
                let longitudDep = aguas.cveDepto.toString().length;

                if (longitudDep > 0 && longitudDep < 4) {
                    diferenciaDep = 4 - longitudDep;
                    departamento = '0';
                    for (d; d < diferenciaDep; d++) {
                        departamento = departamento + '0';
                    }
                    departamento = departamento + departamentoAct;
                    this.aguasForm.patchValue({
                        cveDepto: departamento,
                    });
                    console.log('departamento: ', departamento);
                }
            } else {

            }
        }
    }

    //Formateo de zona, manzana y lote para formar la clave catastral
    async concatenaClave(){
         
        let concatena = '';
        let predios = this.aguasForm.value.cveLote
        let zonas = this.aguasForm.value.cveZona
        let manzanas = this.aguasForm.value.cveManz

        // Formateo ZONA
        if (zonas) {
            const longitudZone = zonas.toString().length;
            const conZone = '0'.repeat(5 - longitudZone) + zonas;
            concatena += conZone;
        }
    
        // Formateo MANZANA
        if (manzanas) {
            const longitudAppe = manzanas.toString().length;
            const conMaz = '0'.repeat(5 - longitudAppe) + manzanas;
            concatena += conMaz;
        }
    
        // Formateo LOTE
        if (predios) {
            const longitudPredios = predios.toString().length;
            const conLte = '0'.repeat(5 - longitudPredios) + predios;
            concatena += conLte;
        }
    
        
    
        this.aguasForm.patchValue({
                cveCatastral: concatena
        }); 

        console.log("CLAVE: ", concatena, this.aguasForm);
         
    }

    async selectCatZonaAgua(zonAgua) {
        if(!zonAgua.value) return;
        this.auxAZona = zonAgua.value.id;
        console.log("ZONAAGUA: ", zonAgua.value.id)
        this.aguasForm.patchValue({idAguaZona : zonAgua.value.id}); 
    }

    async selectCatZona(zonAgua){
        if(!zonAgua.id) return;    
        this.auxAZona = zonAgua.id;
        console.log("AGUAZONA: ", zonAgua.id);
        this.aguasForm.patchValue({idAguaZona : zonAgua.id});

    }

    async selectCatTipoGiro(giro){
        if(!giro.value) return;
        this.auxGiro = giro.value.id;
        console.log("GIRO: ", giro.value.id);
        this.aguasForm.patchValue({idTipoGiro: giro.value.id});
    }

    async selectCatGiro(giro){
        if(!giro.id) return;
        this.auxGiro = giro.id;
        console.log("GIRO: ", giro.id);
        this.aguasForm.patchValue({idTipoGiro: giro.id});
    }
    add() {
        let contratosNew = new GetContratos();
        contratosNew.cambio = true;
        contratosNew.id = 0;
        contratosNew.numRow = this.contratos.length + 1;
        this.contratos.push(contratosNew);  
    }
    onEditInit = (event) => {
        let contratoEdit = event.data;
        contratoEdit.cambio = true; 
        contratoEdit.baja = false;  
        //this.clonedContratos[contratoEdit.numRow] = { ...contratoEdit };
        // No marques cambio como true aquí
    };
    async onEditComplete(event) {
        try {
            let contratoEdit = event.data;
            const contratoClonado = this.clonedContratos[contratoEdit.numRow];

            if (!contratoClonado) {
                contratoEdit.cambio = true;
                contratoEdit.baja = false;
                return;
            }
            // Valida si hay cambios
            if (
                contratoEdit.id === contratoClonado.id &&
                contratoEdit.numContrato === contratoClonado.numContrato &&
                contratoEdit.fecha === contratoClonado.fecha &&
                contratoEdit.idTipoContrato === contratoClonado.idTipoContrato
            ) {
                // No hay cambios, restaura el valor original y marca cambio como false
                let index = this.contratos.findIndex((obj) => obj.numRow === contratoEdit.numRow);
                this.contratos[index] = { ...contratoClonado, cambio: false, baja: false };
                return;
            }
            // Si hay cambios, marca cambio como true
            contratoEdit.cambio = true;
            contratoEdit.baja = false;
          
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
          console.log("Paso por onEditComplete");
        }
    }
    getDescripcionTipoContrato(id: number): string {
        const contrato = this.catTipoContratoPersonas.find(tc => tc.id === id);
        return contrato ? contrato.descripcion : '';
    }
}
